export default __webpack_public_path__ + "static/media/stress-result.767758d4.svg";